import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole } from 'globalutils/fmUtils';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ condition }) => {
  return {
    form_getdata_fields: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    render_cancelSubscription: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => false,
    },
    render_button_update_card: {
      [SERVICE_PROVIDERS.EM]: () => false,
      [SERVICE_PROVIDERS.TP]: () => false,
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      [SERVICE_PROVIDERS.AT]: () => false,
      [SERVICE_PROVIDERS.ELDX]: () => false,
      [SERVICE_PROVIDERS.SIMPLEX]: () => false,
      [SERVICE_PROVIDERS.AZUGA]: () => false,
      [SERVICE_PROVIDERS.TRACKIT]: () => false,
      [SERVICE_PROVIDERS.FT]: () => false,
      [SERVICE_PROVIDERS.HCSS]: () => false,
      [SERVICE_PROVIDERS.PATRIOT]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      default: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
    },
    topaction_payment_button: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      [SERVICE_PROVIDERS.CLUTCH]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      [SERVICE_PROVIDERS.TP]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      default: () => false,
    },
    topaction_pay_btn_label: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => i18n.t('common.update'),
      default: () => i18n.t('companyData.updateCreditCardDetails'),
    },
    topaction_button_update_card: {
      [SERVICE_PROVIDERS.CLUTCH]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      default: () => false,
    },
    topaction_button: {
      [SERVICE_PROVIDERS.EM]: () => false,
      [SERVICE_PROVIDERS.TP]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]) && condition,
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.AT]: () => false,
      [SERVICE_PROVIDERS.ELDX]: () => false,
      [SERVICE_PROVIDERS.SIMPLEX]: () => false,
      [SERVICE_PROVIDERS.AZUGA]: () => false,
      [SERVICE_PROVIDERS.TRACKIT]: () => false,
      [SERVICE_PROVIDERS.FT]: () => false,
      [SERVICE_PROVIDERS.HCSS]: () => false,
      [SERVICE_PROVIDERS.PATRIOT]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]) && condition,
      default: () => !hasRestrictedRole([ROLES.SERVICE_MANAGER]),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
